var React = require('react');
var GameSummary = require('./GameSummary.jsx');

var GameFooter = React.createClass({
    hasValidSummary: function(summary, sport){
        // Return false if summary is not defined (usually happens for future games)
        if (typeof summary === 'undefined'){
            return false;
        }
        var summaryPresent = false;
        try{
            var homeSummaryPresent;
            var awaySummaryPresent;
            if (sport === 'soccer') {
                summaryPresent = summary.home.discipline.length || summary.home.goals.length || summary.away.discipline.length || summary.away.goals.length;
            }
            else if(sport === 'rugby'){
                homeSummaryPresent = summary.home.tries.length || summary.home.cons.length || summary.home.pens.length;
                awaySummaryPresent = summary.away.tries.length || summary.away.cons.length || summary.away.pens.length;
                //console.info('homeSummaryPresent', homeSummaryPresent);
                //console.info('awaySummaryPresent', awaySummaryPresent);
                summaryPresent = homeSummaryPresent > 0 || awaySummaryPresent > 0;
            }
        }catch(e){}
        return summaryPresent;
    },
    render: function(){
        var text = this.props.text;
        var gameStatus = null;
        var gameStatusMobile  = null;
        var gameSummaryWrapper = null;
        if(!!text){
            gameStatus = <div className="game-status">{text}</div>;
            gameStatusMobile = <div className="game-status mobile">{text}</div>;
        }
        if(this.hasValidSummary(this.props.summary, this.props.sport) || gameStatus || gameStatusMobile){
            gameSummaryWrapper = (
                <div className="wrap">
                    <GameSummary summary={this.props.summary} sport={this.props.sport} />
                    {gameStatus}
                    {gameStatusMobile}
                </div>
            );
        }

        return (
            <div style={this.props.styles || {borderBottom:'none'}} className={(this.props.classNames || "game-details footer" + (this.props.sport ? ' ' + this.props.sport : '')) + ( this.props.gameStatus ?  " " + this.props.gameStatus : "")}>
                {gameSummaryWrapper}
            </div>
        );
    }
});

module.exports = GameFooter;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/scoreboard/game-strip/GameFooter.jsx
 **/